<!--
 * @Author: your name
 * @Date: 2023-01-05 10:02:11
 * @LastEditors: your name
 * @LastEditTime: 2023-02-28 16:52:08
 * @FilePath: /developer-black/src/app/routes/project/edit/properties/edit-property/buyer-info/buyer-info.component.html
 * @Description: 
 * 
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved. 
-->
<h4 style="">Buyer</h4>
<div *ngIf="property.buyers && property.buyers.length > 0">
  <div *ngFor="let buyer of property.buyers" class="buyer-item">
    <div style="width: 30%">
      <div style="display: flex">
        <div class="label">Title:</div>
        {{buyer.title === 0 ? 'Company' : (buyer.title === 1 ? 'Mr.' : (buyer.title === 2 ? 'Miss' : (buyer.title === 3 ? 'Mrs.' : (buyer.title === 4 ? 'Dr.' : ''))))}}
      </div>
      <div style="display: flex">
        <div class="label">Name:</div>
        {{buyer.firstName}} {{buyer.lastName}}
      </div>
      <div style="display: flex">
        <div class="label">Email:</div>
        {{buyer.email}}
      </div>
      <div style="display: flex">
        <div class="label">Phone:</div>
        {{buyer.phoneNumber}}
      </div>
      <div style="display: flex">
        <div class="label">Street:</div>
        {{buyer.addressLine2 ? buyer.addressLine2 : '-'}}
      </div>
      <div style="display: flex">
        <div class="label">Suburb:</div>
        {{buyer.area ? buyer.area : '-'}}
      </div>
      <div style="display: flex">
        <div class="label">State:</div>
        {{buyer.state ? buyer.state : '-'}}
      </div>
      <div style="display: flex">
        <div class="label">Postcode:</div>
        {{buyer.postCode ? buyer.postCode : '-'}}
      </div>
      <div style="display: flex">
        <div class="label">Country:</div>
        {{buyer.country ? buyer.country : '-'}}
      </div>
    </div>
    <div style="width: 30%">
      <div style="display: flex">
        <div class="label">FIRB:</div>
        {{buyer.FIRB === 0 ? 'No' : 'Yes'}}
      </div>
      <ng-container *ngIf="buyer.FIRB === 0">
        <div style="display: flex">
          <div class="label">Local investor:</div>
          {{buyer.localInvestor === 0 ? 'No' : 'Yes'}}
        </div>
        <div style="display: flex">
          <div class="label">Local first home buyer:</div>
          {{buyer.localFirstHomeBuyer === 0 ? 'No' : 'Yes'}}
        </div>
        <div style="display: flex">
          <div class="label">Local downsize:</div>
          {{buyer.localDownsize === 0 ? 'No' : 'Yes'}}
        </div>
      </ng-container>
    </div>
    <div style="position: absolute; right: 10px; top: calc(50% - 15px); display: flex">
      <div class="action" style="margin-right: 10px" (click)="openEditBuyerDialog(buyer)" matTooltip="Edit">
        <img src="./assets/images/edit_buyer.svg">
      </div>
      <div class="action" (click)="openUnlinkBuyerDialog(buyer)" matTooltip="Unlink">
        <img src="./assets/images/unlink.svg">
      </div>
    </div>
  </div>
</div>
<button mat-button (click)="openCreateBuyerInfoDialog()" style="background: #161616; margin:10px 0 0 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;color: #DEDEDE;">Create a buyer
</button>